export const isNonNullRecord = (
    item: unknown
): item is Record<string, unknown> => {
    return typeof item === 'object' && item !== null
}

export const isItemWithKeys = (
    item: unknown
): item is Record<string, unknown> | unknown[] => {
    return isNonNullRecord(item) || Array.isArray(item)
}

export const itemHasKey = (item: unknown, key: string): boolean => {
    if (!isItemWithKeys(item)) {
        return false
    }
    return key in item
}

export const itemHasKeys = (item: unknown, keys: string[]): boolean => {
    if (!isItemWithKeys(item)) {
        return false
    }
    let result = true
    keys.forEach((key) => {
        if (!(key in item)) {
            result = false
        }
    })
    return result
}

// Retrieve object value by path
export const deepValue = (
    obj: unknown,
    path: string[],
    defaultValue?: unknown
) => {
    if (!path || !isItemWithKeys(obj)) {
        return defaultValue
    }
    let result: any = obj
    for (const key of path) {
        if (!itemHasKey(result, key) || typeof result[key] === 'undefined') {
            return defaultValue
        }
        result = result[key]
    }
    return result
}
